import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Form, Alert, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faBan } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { options, params } from '../../actions/webServices';
import { isPhoneSaleSucursal } from '../../utilities';
import SpinnerLoading from '../SpinnerLoading';
import PhoneSaleCardForm from './PhoneSaleCardForm';
import '../ConfirmBuy/styles.css';

function ConfirmBuy({ codpmpol }) {
    const url = process.env.NODE_ENV === 'development' ? `${process.env.REACT_APP_NODE_APP}/accept` : process.env.REACT_APP_FINAL_CLIENT_URL
    const [show, setShow] = useState(false);
    const [showBtn, setShowBtn] = useState(true);
    const [loading, setLoading] = useState(true);
    const [cancelPurchase, setCancelPurchase] = useState(false);
    const [redirectError, setRedirectError] = useState(false);
    const [confirmado, setConfirmado] = useState(false);
    const [state, setState] = useState({
        acepto: false,
        cia: '',
        codemp: 0,
        codigo: null,
        codsec: '',
        codsuc: '',
        completo: false,
        dni: '',
        estado: null,
        expired: false,
        fecpro: '',
        formaPago: '',
        nombre: '',
        numero: '',
        pago: '',
        plan: '',
        producto: '',
        rechazado: false,
    });
    const isPhoneSale = isPhoneSaleSucursal(state.codemp, state.codsuc);
    const hidePayment = state.codsec === "27" || isPhoneSale;

    const accept = () => {
        if (state.cia == 'MAWDY' || state.codsec == 27) {
            setLoading(true);
            params.set('opcpm', "confirmar");
            params.set('codpmpol', codpmpol);
            axios.post(url, params, options)
                .then(r => {
                    if (r?.data?.codpmpol === "ok" && r?.data?.urlDebito) {
                        window.location.href = r.data.urlDebito;
                    }
                    else {
                        setLoading(false);
                        setRedirectError(true);
                    }
                });
        } else if (isPhoneSale) {
            // Venta telefónica: nunca dispara opcpm=confirmar acá, la tarjeta
            // se confirma más adelante desde PhoneSaleCardForm.
            setState({ ...state, completo: true });
        } else {
            setState({ ...state, completo: true });
        }
    };
    const handleCancel = () => {
        setShow(true);
        setCancelPurchase(true);
    };
    const handleConfirm = () => {
        setLoading(true);
        params.set('opcpm', "confirmar");
        params.set('codpmpol', codpmpol);
        axios.post(url, params, options)
            .then(r => {
                setLoading(false);
                if (r?.data?.codpmpol === "ok" && r?.data?.urlDebito) {
                    window.location.href = r.data.urlDebito;
                }
            });
        setShowBtn(false);
        setCancelPurchase(false);
        setShow(true);
    };
    const handleClose = () => { setShow(false) };
    const handleReject = () => {
        setLoading(true)
        handleClose();
        setShowBtn(false);
        params.set('opcpm', 'Reject');
        params.set('codpmpol', codpmpol);
        axios.post(url, params, options)
            .then((r) => {
                if (r.data.codpmpol === "ok") {
                    setState({ ...state, rechazado: true });
                }
                setLoading(false);
            })
    }

    useEffect(() => {
        params.set('opcpm', 'Accept');
        params.set('codpmpol', codpmpol);
        axios.post(url, params, options)
            .then((r) => {
                setState((s) => ({ ...s, ...r.data }));
                setLoading(false);
            })
    }, [codpmpol, url]);

    return (
        <>
            {
                loading ? <SpinnerLoading /> : (
                    state.completo && !state.rechazado ? (
                        isPhoneSale ? (
                            confirmado ? (
                                <Alert className='my-3' variant='success'>
                                    <p>
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                        ¡Gracias por confirmar la contratación del seguro de {state.producto}!
                                    </p>
                                </Alert>
                            ) : (
                                <PhoneSaleCardForm
                                    codpmpol={codpmpol}
                                    url={url}
                                    producto={state.producto}
                                    pago={state.pago}
                                    onSuccess={() => setConfirmado(true)}
                                />
                            )
                        ) : (
                            <>
                                <Alert className='my-3' variant='success'>
                                    <p>
                                        <FontAwesomeIcon icon={faCircleCheck} />
                                        ¡Gracias por confirmar la contratación del seguro de {state.producto}!
                                    </p>
                                    {state.codigo === "I" && <p>Ya le puedes avisar al vendedor para que emita el seguro.</p>}
                                </Alert>
                                {
                                    showBtn &&
                                    <>
                                        <Button className='btn-success' onClick={handleConfirm}>Ya le avisé al vendedor</Button>
                                        <Button className='btn-danger' onClick={handleCancel}>Revocar compra</Button>
                                    </>
                                }
                            </>
                        )
                    ) : state.rechazado ? (
                        <Alert className='my-3' variant='danger'>
                            <p>
                                <FontAwesomeIcon icon={faBan} />
                                ¡La solicitud de su seguro fue revocada exitosamente!
                            </p>
                        </Alert>
                    ) : state.codigo === "R" || state.codigo === "RC" ?
                        (
                            <div className="qs-inputs row row-cols-1 mb-4 confirm">
                                <h1 className='text-initial'>{`${state.nombre !== "" ? state.nombre : "Hola"}, tu póliza de ${state.producto} se encuentra en estado ${state.estado}.`}</h1>
                            </div>
                        ) : (
                            <>
                                <div className="qs-inputs mb-4 custom-border-2 m-auto confirm">
                                    {
                                        !state.expired &&
                                        <h2 className='text-start mb-3'>{state.codigo === "I" || state.codsec === "27" ? "Ya estás a un paso de contratar tu seguro" : `Tu póliza se encuentra en estado ${state.estado}.`}</h2>
                                    }
                                    <div className='m-0 ms-3'>
                                        <label className='labels w-100 mb-2'>Nombre y Apellido:</label>
                                        <label className='labels-info w-100 mb-2'>{state.nombre}</label>
                                        <label className='labels w-10 mb-2'>DNI:</label>
                                        <label className='labels-info w-100 mb-2 '>{state.dni}</label>
                                        {!hidePayment && <label className='labels w-100 mb-2'>Forma de pago:</label>}
                                        {!hidePayment && <label className='labels-info w-100 mb-2 '>{state.formaPago}</label>}
                                        {
                                            !hidePayment && (
                                                state.codpag === 1
                                                    ? <label className='labels w-100 mb-2'>Tarjeta:</label>
                                                    : state.codpag === 2 && <label className='labels w-100 mb-2'>Cuenta:</label>
                                            )
                                        }
                                        {!hidePayment && state.codpag !== 3 && <label className='labels-info w-100 mb-2'>{state.numero}</label>}
                                        <label className='labels w-100 mb-2'>Compañía:</label>
                                        <label className='labels-info w-100 mb-2 '>{state.cia}</label>
                                        <label className='labels w-100 mb-2'>Producto:</label>
                                        <label className='labels-info w-100 mb- '>{state.producto}</label>
                                        {state.codsec !== "27" && <label className='labels w-100 mb-2'>Plan:</label>}
                                        {state.codsec !== "27" && <label className='labels-info w-100 mb- '>{state.plan}</label>}
                                        <label className='labels w-100 mb-2'>Pago por mes:</label>
                                        <label className='labels-info w-100 mb-2 '>{state.pago}</label>
                                    </div>
                                </div>

                                {
                                    (state.codigo === "I" || (state.codigo === "P" && state.codsec === "27")) && !state.expired &&
                                    <div className='d-flex'>
                                        <Form.Check
                                            inline
                                            name="accept"
                                            checked={state.acepto}
                                            onChange={() => setState({ ...state, acepto: !state.acepto })}
                                            type="checkbox"
                                            id="inline-checkbox-1"
                                        />
                                        <a
                                            target="_blank"
                                            rel="noreferrer"
                                            href={`https://www.platform.com.ar/terminos/terminos-${state.codemp < 50 ? state.codemp : state.codemp - 50}-${state.codsec}.pdf`}
                                        >
                                            <label className="term-and-cond">Acepto los términos y condiciones</label>
                                        </a>
                                    </div>
                                }
                                {
                                    (state.codigo === "R" || state.codigo === "RC")? 
                                        ''
                                        : 
                                        (state.codigo === "I" || (state.codigo === "P" && state.codsec === "27")) ?
                                            !state.expired ?
                                                <Button onClick={accept} className={"main-btn mt-3"} disabled={!state.acepto} variant='primary'>{state.codsec === "27" ? 'Ir al pago' : 'Confirmar'}</Button>
                                                :
                                                <Button variant="danger" className="mt-4">Solicitud de contratación expirada</Button>
                                            : 
                                            state.codigo === "P" && ( state.codsec === "12" ? 
                                                <p className='text-center'>Error al tokenizar la tarjeta</p>
                                                :
                                                <Button onClick={handleCancel} className={"revocar-compra mt-3"} disabled={state.acepto}>Deseo revocar mi compra</Button> )
                                }
                            </>
                        )
                )
            }
            <Modal show={show} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title><FontAwesomeIcon icon={cancelPurchase ? faTrash : faCircleCheck} /> ¡Aviso!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        cancelPurchase
                            ? <p>¿Realmente desea revocar la compra del seguro?</p>
                            : <p>¡Ha finalizado su compra!</p>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose} className={'main-btn'}>
                        {cancelPurchase ? 'Cancelar' : 'Cerrar'}
                    </Button>
                    {
                        cancelPurchase &&
                        <Button variant="danger" onClick={handleReject}>
                            Sí, revocar
                        </Button>
                    }
                </Modal.Footer>
            </Modal>
            <Modal show={redirectError} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title><FontAwesomeIcon icon={faCircleCheck} /> ¡Aviso!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                   <p>Ha ocurrido un error al redireccionarle a su pasarela de pago.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=>{setRedirectError(false)}} className={'main-btn'}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ConfirmBuy;
